module.exports = __webpack_public_path__ + "static/media/celebrate.53dbee25.svg";